import { render, staticRenderFns } from "./CampusInfoExpansionPanelHeader.vue?vue&type=template&id=40d999c8&scoped=true&"
import script from "./CampusInfoExpansionPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./CampusInfoExpansionPanelHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d999c8",
  null
  
)

export default component.exports